import "./form-transaction-waiver.scss";
import { useFormContext } from "react-hook-form";
import { TransactionWaiverFormSchema } from "@factory/form/form.rule";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import { useQyGetWaiver } from "@factory/query/waiver.query";
import { useState } from "react";
import {
  GetResponseWaiverModel,
  GetWaiverModel,
} from "@factory/model/query-model-waiver";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { LabelValue } from "@shared/models/label-value.interface";
import { keyBy } from "lodash-es";

type InputFormSchema = TransactionWaiverFormSchema;
export function FormTransactionWaiver() {
  const { control, setValue } = useFormContext<TransactionWaiverFormSchema>();
  const [waiverList, setWaiverList] = useState<LabelValue[]>([]);

  const waiverApiSuccess = (response: GetResponseWaiverModel) => {
    const data = response.data ?? [];
    if (data.length === 0) {
      return;
    }

    const labelOption = LabelValue.MapArray(
      data,
      (item) => item.name,
      (item) => item.code,
      (item) => item
    );
    setWaiverList(labelOption);
  };
  const { data: response } = useQyGetWaiver(
    "",
    9999,
    0,
    undefined,
    undefined,
    true,
    waiverApiSuccess
  );
  const dataResponse = response?.data ?? [];
  const dataResponseEntity = keyBy(dataResponse, "code");

  return (
    <div id="FormTransactionWaiver" className="transaction-waiver">
      <DropdownControl<InputFormSchema>
        control={control}
        name="waiver"
        label="Waiver"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter waiver"
        options={waiverList}
        onSelect={(item) => setValue("waiverMeta", dataResponseEntity[item])}
      />
    </div>
  );
}

export default FormTransactionWaiver;
